import { useCallback, useContext } from 'react';
import { setMemberState } from './MemberStore';
import { AuthContext } from '@/contexts/AuthContext';
import { useWorkspaceId } from 'app/[locale]/w/[workspaceId]/components/useWorkspaceHooks';

export function useFetchMembers() {
  const { authState } = useContext(AuthContext);
  const workspaceId = useWorkspaceId();

  return useCallback(async () => {
    if (authState.type !== 'signedIn') return;
    const { callaboApiClient } = authState;
    setMemberState({ type: 'loading' });
    try {
      const _members = await callaboApiClient.members.getMembersV1WorkspacesSlugMembersGet(
        workspaceId
      );
      const members = _members.map((member) => ({
        id: member.id,
        userId: member.user_id,
        email: member.email,
        name: member.name,
        workspaceRoles: member.workspace_roles,
        baseRole: member.base_role,
        teams: member.teams,
      }));
      setMemberState({
        type: 'loaded',
        detail: members,
      });
    } catch (e) {
      setMemberState({ type: 'error', error: e });
      throw e;
    }
  }, [authState.type, workspaceId]);
}
